module.exports = __webpack_public_path__ + "static/media/onnx_model.286d4874.onnx";